export enum SortDirection {
  Ascending,
  Descending
}
export type Sort = {
  sortColumn: string;
  sortDirection: SortDirection;
};
